<script setup lang="ts">
import ChartComponent from './elements/ChartComponent.vue';


const props = defineProps<{ type: string }>();
</script>

<template>
  <div>
    <ChartComponent :type="props.type" extra-class=""></ChartComponent>
  </div>
</template>